module.exports = __webpack_public_path__ + "src/assets/images/icon-restroom-male.svg?1815d0ff24481c86af3ace3c6ba9c0e2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-restroom-male.svg
// module id = 595
// module chunks = 0